import t from"./isObject.esm.js";function e(e){return!0===e.additionalItems&&console.warn("additionalItems=true is currently not supported"),t(e.additionalItems)}export{e as default};
